import formatString from 'utils/formatString'
import IconRenderer, { Icon } from './IconRenderer'
import NextLink from 'next/link'
import { CAREERS_SLUG } from 'common/constants'
import { Card } from 'designsystem/Card'

interface JobDepartmentsListProps extends React.HTMLAttributes<HTMLDivElement> {
  departments: GreenhouseEveryDepartment
  cardStyle?: boolean
}

const JobDepartmentsList = ({
  departments,
  cardStyle = false,
  ...props
}: JobDepartmentsListProps): JSX.Element | null => {
  return departments.length > 0 ? (
    <div {...props}>
      <ul
        className={
          cardStyle
            ? 'flex flex-wrap justify-start md:justify-center -mt-6 md:-mt-8'
            : 'grid grid-cols-2 gap-10 md:flex md:justify-center md:flex-wrap md:gap-0 md:-mt-10 lg:-mt-16'
        }
      >
        {departments.map((department) => {
          const { id, name, jobs } = department
          const formattedDepartmentName = formatString(name)

          return (
            <li
              key={id}
              className={
                cardStyle
                  ? 'mr-6 mt-6 md:mr-8 md:mt-8'
                  : 'md:mt-10 md:mr-10 lg:mt-16 lg:mr-16'
              }
            >
              <NextLink
                href={
                  jobs.length > 0
                    ? `${CAREERS_SLUG}#${formattedDepartmentName}-jobs`
                    : `${CAREERS_SLUG}#dream-job`
                }
                className='font-demibold h-full'
              >
                {cardStyle ? (
                  <Card
                    noPadding
                    noMaxWidth
                    hoverable
                    className='flex items-center h-full p-6 md:p-8'
                  >
                    <IconRenderer
                      icon={formattedDepartmentName as Icon}
                      className='h-10 md:h-12 w-auto mr-4 md:mr-6 text-blue'
                    />

                    <div className='flex flex-col'>
                      <span>{name}</span>

                      <NumberOfJobs jobs={jobs} />
                    </div>
                  </Card>
                ) : (
                  <div className='flex flex-col items-start md:items-center'>
                    <IconRenderer
                      icon={formattedDepartmentName as Icon}
                      className='h-8 w-auto mb-4 text-blue'
                    />

                    <span>{name}</span>

                    <NumberOfJobs jobs={jobs} />
                  </div>
                )}
              </NextLink>
            </li>
          )
        })}
      </ul>
    </div>
  ) : null
}

export default JobDepartmentsList

const NumberOfJobs = ({ jobs }: { jobs: GreenhouseJob[] }) => {
  return (
    <small className='opacity-50 spacer-4xs'>
      {jobs.length > 0
        ? `${jobs.length} ${jobs.length === 1 ? 'Job' : 'Jobs'}`
        : '1 Job'}
    </small>
  )
}
